export default function Privacidad() {
  return (
    <div data-testid="privacidad-page" className="py-20">
      <div className="container-max max-w-3xl">
        <div className="mb-10">
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-3">Política de privacidad</h1>
          <p className="text-slate-500 text-sm">Última actualización: 19 de enero de 2023</p>
        </div>

        <div className="prose-article">
          <p>
            La presente Política de Privacidad ha sido desarrollada teniendo en cuenta lo dispuesto por la
            Ley Orgánica de Protección de Datos de carácter personal en vigor, así como por el Reglamento
            2016/679 del Parlamento Europeo y del Consejo del 27 de abril de 2016 relativo a la protección
            de las personas físicas en lo que respecta al tratamiento de datos personales y a la circulación
            de estos datos, en adelante el RGPD.
          </p>
          <p>
            Esta Política de Privacidad tiene por objeto poner en conocimiento de los titulares de los datos
            personales, respecto de los cuales se está recabando información, los aspectos específicos relativos
            al tratamiento de sus datos, entre otras cosas, las finalidades de los tratamientos, los datos de
            contacto para ejercer los derechos que le asisten, los plazos de conservación de la información y
            las medidas de seguridad entre otras cosas.
          </p>

          <h2>Responsable del Tratamiento</h2>
          <ul>
            <li><strong>Denominación:</strong> DOCTORES PINA SLP</li>
            <li><strong>Dirección:</strong> Travessera de les Corts 82 bjs-08028 Barcelona</li>
            <li><strong>Teléfono de contacto:</strong> 933 301 724</li>
            <li><strong>Correo electrónico:</strong> doctores.pina@hotmail.com</li>
            <li><strong>Delegado de Protección de Datos:</strong> TECNODOSIS SL — dpd@utpr.es</li>
          </ul>

          <h2>Tratamientos de datos</h2>
          <p>
            Los datos de carácter personal que se soliciten, en su caso, consistirán únicamente en aquellos
            estrictamente imprescindibles para identificar y atender la solicitud realizada por el titular de
            los mismos, en adelante el interesado. Dicha información será tratada de forma leal, lícita y
            transparente en relación con el interesado. Por otra parte, los datos personales serán recogidos
            para finalidades determinadas explícitas y legítimas, no siendo tratados ulteriormente de manera
            incompatible con dichos fines.
          </p>
          <p>
            Los datos recogidos de cada interesado serán adecuados, pertinentes y no excesivos en relación a
            las finalidades correspondientes para cada caso, y serán actualizados siempre que sea necesario.
          </p>
          <p>
            El titular de los datos será informado, con carácter previo a la recogida de sus datos, de los
            extremos generales regulados en esta política a fin de que pueda prestar el consentimiento expreso,
            preciso e inequívoco para el tratamiento de sus datos.
          </p>

          <h2>Finalidades del tratamiento</h2>
          <p>
            Las finalidades explícitas para las cuales se llevan a cabo cada uno de los tratamientos vienen
            recogidas en las cláusulas informativas incorporadas en cada una de las vías de toma de datos
            (formularios web, newsletter, etc.). No obstante, los datos de carácter personal del interesado
            serán tratados con la exclusiva finalidad de proporcionarles una respuesta efectiva y atender las
            solicitudes practicadas por el usuario.
          </p>

          <h2>Legitimación</h2>
          <p>
            Por regla general, previo al tratamiento de los datos personales, DOCTORES PINA SLP obtiene
            consentimiento expreso e inequívoco del titular de los mismos, mediante la incorporación de
            cláusulas de consentimiento informado en los diferentes sistemas de recogida de información.
          </p>
          <p>
            No obstante, en caso de que no se requiera el consentimiento del interesado, la base legitimadora
            del tratamiento en la cual se ampara DOCTORES PINA SLP es la existencia de una ley o norma específica
            que autorice o exija el tratamiento de los datos del interesado.
          </p>

          <h2>Destinatarios</h2>
          <p>
            Por regla general, DOCTORES PINA SLP no procede a la cesión o comunicación de los datos a terceras
            entidades, salvo las requeridas legalmente. No obstante, en caso de que fuera necesario, dichas
            cesiones o comunicaciones de datos se informan al interesado a través de las cláusulas de consentimiento
            informado contenidas en las diferentes vías de recogida de datos personales.
          </p>

          <h2>Procedencia</h2>
          <p>
            Por regla general, los datos personales se recogen siempre directamente del interesado. No obstante,
            en determinadas excepciones, los datos pueden ser recogidos a través de terceras personas, entidades
            o servicios diferentes del interesado. En este sentido, este extremo será trasladado al interesado a
            través de las cláusulas de consentimiento informado contenidas en las diferentes vías de recogida de
            información y dentro de un plazo razonable, una vez obtenidos los datos, y a más tardar dentro de un mes.
          </p>

          <h2>Plazos de conservación</h2>
          <p>
            La información recabada del interesado será conservada mientras sea necesaria para cumplir con la
            finalidad para la cual fueron recabados los datos personales, de forma que, una vez cumplida la finalidad,
            los datos serán cancelados. Dicha cancelación dará lugar al bloqueo de los datos conservándose únicamente
            a disposición de las AAPP, Jueces y Tribunales, para atender las posibles responsabilidades nacidas del
            tratamiento, durante el plazo de prescripción de éstas; cumplido el citado plazo se procederá a la
            destrucción de la información.
          </p>

          <h2>Datos de navegación</h2>
          <p>
            En relación a los datos de navegación que se puedan tratar a través del sitio web, en caso de que se
            recojan datos sometidos a la normativa, se recomienda consultar la Política de Cookies publicada en
            nuestro sitio web.
          </p>

          <h2>Derechos de los interesados</h2>
          <p>
            La normativa en materia de protección de datos otorga una serie de derechos a los interesados o
            titulares de los datos, usuarios del sitio web o usuarios de los perfiles de las redes sociales de
            DOCTORES PINA SLP. Estos derechos son los siguientes:
          </p>
          <ul>
            <li><strong>Derecho de acceso:</strong> derecho a obtener información sobre si sus propios datos están siendo objeto de tratamiento, la finalidad del tratamiento, las categorías de datos, los destinatarios o categorías de destinatarios, el plazo de conservación y el origen de dichos datos.</li>
            <li><strong>Derecho de rectificación:</strong> derecho a obtener la rectificación de los datos personales inexactos o incompletos.</li>
            <li><strong>Derecho de supresión:</strong> derecho a obtener la supresión de los datos personales.</li>
            <li><strong>Derecho de oposición:</strong> derecho a oponerse a un determinado tratamiento basado en el consentimiento del interesado.</li>
            <li><strong>Derecho de limitación:</strong> derecho a obtener la limitación del tratamiento de los datos.</li>
            <li><strong>Derecho a la portabilidad:</strong> derecho a obtener los datos en un formato estructurado, de uso común y de lectura mecánica, y a transmitirlos a otro responsable del tratamiento conforme a la normativa de protección de datos.</li>
          </ul>
          <p>
            Asimismo, el interesado tiene derecho a presentar una reclamación ante la autoridad de control competente.
          </p>
          <p>
            Los interesados podrán ejercitar los derechos indicados dirigiéndose a{" "}
            <a href="mailto:doctores.pina@hotmail.com" className="text-teal-700 underline">doctores.pina@hotmail.com</a>{" "}
            mediante escrito, remitido a la siguiente dirección: Travessera de les Corts 82 bjs-08028 Barcelona,
            indicando en la línea de Asunto el derecho que desea ejercitar y adjuntando documento acreditativo de
            la identidad (por ejemplo, DNI).
          </p>
          <p>
            En este sentido, DOCTORES PINA SLP atenderá su solicitud a la mayor brevedad posible y teniendo en
            cuenta los plazos previstos en la normativa en materia de protección de datos.
          </p>

          <p className="text-slate-500 text-sm mt-10">En Barcelona, a 19 de enero del 2023</p>
        </div>
      </div>
    </div>
  );
}
